import BorderLeftBox from "../../components/boxes/BorderLeftBox"
import riskPageData from "../../data/english/subpages/risk-page-data"
import Footer from "../../layouts/Footer"
import MainHeader from "../../layouts/MainHeader"

const RiskPage = () => {
  return (
    <main className="page" id="main">
      <div className="sticky-view-two">
        <div className="sticky-container">
          <MainHeader
            title=""
            image={{
              src: require(`../../assets/images/wallpaper/${riskPageData.header.image.name}`),
              alt: riskPageData.header.image.alt,
            }}
          />
        </div>
        <div className="sticky-container-two">
          <div className="wrapper-small">
            <h1 className='title-center'>{riskPageData.mainTitle}</h1>
            <p className="text-paragraph">{riskPageData.paragraphOne}</p>
            <ul className="normal-list">
              {riskPageData.listOne.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            {/* <p className="text-paragraph">{riskPageData.paragraphTwo}</p>
        <p className="text-paragraph">{riskPageData.paragraphThree}</p>
        <p className="text-paragraph">{riskPageData.paragraphFour}</p> */}
            <div className="space-50"></div>
            <BorderLeftBox
              title={riskPageData.borderLeftBox.title}
            />
            <p className="text-paragraph">{riskPageData.paragaphSix}</p>
            <ul className="normal-list">
              {riskPageData.list.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            <p className="text-paragraph">{riskPageData.paragraphFive}</p>
            <p className="text-paragraph">{riskPageData.paragraphSeven}</p>
            <p className="text-paragraph">{riskPageData.paragraphEight}</p>
            <ul className="normal-list">
              {riskPageData.listTwo.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            <img src={require('../../assets/images/sections/risk-management.png')} className="tab-wallpaper-image"></img>
            <div className="space-50"></div>
            {/* <BorderLeftBox
              title={riskPageData.borderLeftBoxTwo.title}
              subtitle={riskPageData.borderLeftBoxTwo.subtitle}
            /> */}
            <div className="space-50"></div>
            <div className="space-50"></div>
            <div className="space-50"></div>
          </div>
          <Footer withBlogs={false} />
        </div>
      </div>
    </main>
  )
}

export default RiskPage